/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KnowledgeLink = {
    icon: string;
    title: string;
    chip_type: string;
    link_type: KnowledgeLink.link_type;
    url: string;
    sort_order: number;
    id: number;
    created_at: string;
    updated_at: string;
};

export namespace KnowledgeLink {

    export enum link_type {
        URL = 'url',
        EXTERNAL_URL = 'external_url',
        ASK_QUERY = 'ask_query',
    }


}

